'use client';
import { jsx } from 'react/jsx-runtime';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const InputWithFloatingLabel = renderWithRef('InputWithFloatingLabel', null, (r, o)=>{
    let { children: a } = r;
    return jsx(FloatingLabelContextProvider, {
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: o,
            props: r,
            classNames: [
                'swan-vanilla-ignore',
                'swan-input-with-floating-label'
            ],
            children: a
        })
    });
});

export { InputWithFloatingLabel };
